import config from "../config/config.js"

//валидация email
export function isValidEmail($emailNode) {
    let reg = /^(\S)+@([\S])+\.([\S]{1,20})$/,
        val = $emailNode.val();

    let isValid = true;

    if (val.length > 0 && !reg.test(val)) {
        $emailNode.siblings(".error").text("Некорректный email");
        $emailNode.addClass("invalid");
        isValid = false;
    }

    return isValid;
}

//валидация формы на обязательные поля
export function isValidForm($form) {

    let isValidFields = true,
        isValidEmails = true;

    $form.find("[required]").each(function() {

        if ($(this).val().length == 0) {

            $(this).siblings(".error").text("Это поле обязательно для заполнения");
            $(this).addClass("invalid");
            isValidFields = false;
        } else {

            $(this).removeClass("invalid");
        }
    });

    $form.find("input[type='email']").each(function() {
        if (!isValidEmail($(this))) {
            isValidEmails = false;
        }
    });

    return isValidFields && isValidEmails;
}

//проверка согласия с политикой конфиденциальности
export function checkAgreement($agreementNode, $buttonNode) {

    if ($agreementNode.prop("checked")) {
        $buttonNode.removeClass("disabled");
    } else {
        $buttonNode.addClass("disabled");
    }

    $agreementNode.on("change", function() {
        if ($(this).prop("checked")) {
            $buttonNode.removeClass("disabled");
        } else {
            $buttonNode.addClass("disabled");
        }
    });
}

//убрать сообщение об ошибке
export function checkInput($form) {

    $form.find("input, textarea").each(function() {

        $(this).on("keyup", function() {

            $(this).removeClass("invalid");
        });
    });
}

//замена типа метода отправки формы в режиме раработки
export function formMethod(realMethod) {
    if (config.production) {
        return realMethod;
    }
    return "get";
}

// recaptcha
export function loadCaptchaToken() {
    /* eslint-disable */
    if (typeof (grecaptcha) == "undefined") {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://www.google.com/recaptcha/api.js?render=" + window.config.recaptcha.public_key;
        $("body").append(script);
    }
    grecaptcha.ready(function () {
        grecaptcha.execute(window.config.recaptcha.public_key, {action: "validate_captcha"})
            .then(function (token) {
                $(".js-form-feedback").find("[name=g-recaptcha-response]").val(token);
            });
    });
    /* eslint-enable */
}


